import { render, staticRenderFns } from "./EducationLanguages.vue?vue&type=template&id=0fad40cd&"
import script from "./EducationLanguages.vue?vue&type=script&lang=js&"
export * from "./EducationLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports